import { getSeedingProposalRejectionReasons } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetSeedingRejectionReasonsServiceResponse } from './get-seeding-rejection-reasons.dto';
import { GetSeedingRejectionReasonsServiceResponseSchema } from './get-seeding-rejection-reasons.dto';

export const getSeedingRejectionReasonsService = withServiceErrorCapture(
  lazyPipe(async (): Promise<GetSeedingRejectionReasonsServiceResponse> => {
    const apiResponse = await getSeedingProposalRejectionReasons();

    if (apiResponse.meta?.result === 'FAIL') {
      throw new Error(apiResponse.meta?.message ?? '거절 사유 목록 조회에 실패했습니다.');
    }

    return apiResponse.data;
  }, validateServiceResponse(GetSeedingRejectionReasonsServiceResponseSchema)),
);
